const addHatFunction = () => {
    return async (dispatch, getState, { getFirestore }) => {
        const db = getFirestore()
        const getUid = getState().firebase.auth.uid
        const getLevel = getState().firebase.profile.level
        const getComments = getState().firebase.profile.comments
        const getFavCountries = getState().firebase.profile.favoriteCountries
        const getAchievs = getState().firebase.profile.achievements
        const getCurrentHats = getState().firebase.profile.inventory.hats
        const getBag = getState().firebase.profile.inventory.bag
        const completedTravels = getState().firebase.profile.travels.completedTravels

        const requestHatsArray = await db.collection('items').doc('hats').get()
        const getHatsArray = requestHatsArray.data()

        const requestAchievementsArray = await db.collection('achievements').doc('achievements').get()
        const getAchievementsArray = requestAchievementsArray.data()

        const countryCapCondition = (countryName) => {
            return completedTravels.find(item => item === `${countryName} cap-1` || item === `${countryName} cap-2` || item === `${countryName} cap-3`)
        }

        const countryHatCondition = (countryName) => {
            const filterTravels = completedTravels.filter(item => item.includes(countryName))
            return filterTravels.length === 3 ? true : false
        }


        const checkHatConditions = (item) => {
            if (!getCurrentHats.find(hat => item.name === hat.name)) {
                let checkCondition

                if (!item.img.includes('hat') && !item.img.includes('cap')) {
                    switch (item.name) {
                        case 'Boné Adventour':
                            checkCondition = getLevel === 5 && getComments.length >= 10 && getFavCountries.length >= 3 ? true : false
                            break;
                        case 'Chapéu Indiana Jones':
                            checkCondition = getLevel === 10 ? true : false
                            break;
                        case 'Tiara brilhante':
                            checkCondition = getAchievs.length === getAchievementsArray.achievs.length - 1 ? true : false
                            break;
                        default:
                            break;
                    }
                } else {
                    if (item.img.includes('cap')) {
                        checkCondition = countryCapCondition(item.country)
                    } else if (item.img.includes('hat')) {
                        checkCondition = countryHatCondition(item.country)
                    }
                }

                if (checkCondition) {
                    dispatch({ type: 'HAT_FOUND_SUCCESS', payload: item.name })
                    return item
                } else {
                    dispatch({ type: 'NO_HAT_FOUND' })
                }
            } else {
                dispatch({ type: 'ALREADY_HAS_HAT' })
            }
        }

        let foundHats = []

        // loop to check conditions and give users possible hats
        for (let item of getHatsArray.items) {
            let hat = checkHatConditions(item)
            hat && foundHats.push(hat)
        }

        if (foundHats.length !== 0) {
            try {
                await db.collection('users').doc(getUid).update({
                    inventory: {
                        bag: [...getBag],
                        hats: getCurrentHats.concat(...foundHats)
                    }
                })
                dispatch({ type: 'ADD_HATS_SUCCESS' })
            } catch (err) {
                console.log(err)
                dispatch({ type: 'ADD_HATS_ERROR', error: err })
            }
        }
    }
}

export default addHatFunction
